import { Link } from "react-router-dom";
import { Package, Mail, Phone, MapPin, Linkedin, Instagram, Facebook } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground mt-auto w-full">
      <div className="w-full max-w-7xl mx-auto px-4 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-12">
          {/* Logo & Description */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-xl bg-secondary flex items-center justify-center">
                <Package className="w-5 h-5 text-secondary-foreground" />
              </div>
              <span className="text-2xl font-heading font-bold">
                GoBled<span className="text-secondary">Pro</span>
              </span>
            </Link>
            <p className="text-primary-foreground/80 mb-6 max-w-md">
              La plateforme de confiance pour le transport de colis entre la France et le Maroc.
              Mise en relation avec des transporteurs professionnels vérifiés.
            </p>
            <div className="flex flex-col gap-2 text-primary-foreground/70 text-sm">
              <div className="flex items-center gap-2">
                <Mail className="w-4 h-4" />
                <span>gobledpro@gmail.com</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="w-4 h-4" />
                <span>+33 9 55 44 39 02</span>
              </div>
              <div className="flex items-center gap-2">
                <MapPin className="w-4 h-4" />
                <span>Paris, France</span>
              </div>
            </div>
            <div className="flex items-center gap-4 mt-4">
              <a 
                href="https://www.linkedin.com/company/gobledpro" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-primary-foreground/70 hover:text-secondary transition-colors"
                aria-label="LinkedIn GoBledPro"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a 
                href="https://www.instagram.com/gobledpro/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-primary-foreground/70 hover:text-secondary transition-colors"
                aria-label="Instagram GoBledPro"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href="https://www.facebook.com/profile.php?id=61585365316641" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-primary-foreground/70 hover:text-secondary transition-colors"
                aria-label="Facebook GoBledPro"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Liens utiles */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-4">Liens utiles</h4>
            <ul className="space-y-3">
              <li>
                <a href="#fonctionnement" className="text-primary-foreground/70 hover:text-secondary transition-colors">
                  Comment ça marche
                </a>
              </li>
              <li>
                <Link to="/demande-transport" className="text-primary-foreground/70 hover:text-secondary transition-colors">
                  Demander un transport
                </Link>
              </li>
              <li>
                <Link to="/devenir-transporteur" className="text-primary-foreground/70 hover:text-secondary transition-colors">
                  Devenir transporteur
                </Link>
              </li>
              <li>
                <Link to="/faq-transport-colis-maroc" className="text-primary-foreground/70 hover:text-secondary transition-colors">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Confiance */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-4">Confiance</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/transport-colis-maroc-fiable" className="text-primary-foreground/70 hover:text-secondary transition-colors">
                  Transport fiable
                </Link>
              </li>
              <li>
                <Link to="/transporteurs-verifies-maroc" className="text-primary-foreground/70 hover:text-secondary transition-colors">
                  Transporteurs vérifiés
                </Link>
              </li>
              <li>
                <Link to="/avis-transport-colis-france-maroc" className="text-primary-foreground/70 hover:text-secondary transition-colors">
                  Avis clients
                </Link>
              </li>
            </ul>
          </div>

          {/* Légal */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-4">Informations légales</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/mentions-legales" className="text-primary-foreground/70 hover:text-secondary transition-colors">
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link to="/cgu" className="text-primary-foreground/70 hover:text-secondary transition-colors">
                  Conditions Générales d'Utilisation
                </Link>
              </li>
              <li>
                <Link to="/confidentialite" className="text-primary-foreground/70 hover:text-secondary transition-colors">
                  Politique de confidentialité
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-primary-foreground/20 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-primary-foreground/60 text-sm text-center md:text-left">
              © {new Date().getFullYear()} GoBledPro. Tous droits réservés.
            </p>
            <div className="bg-secondary/20 border border-secondary/30 rounded-lg px-4 py-2">
              <p className="text-secondary text-sm font-medium text-center">
                ⚠️ GoBledPro n'est pas un transporteur. Nous sommes une plateforme de mise en relation.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
